import React from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { Tooltip } from 'antd'
import { TComplaintStatus } from '../model/types/ComplaintStatus.type'

const statusClass: Record<TComplaintStatus, string> = {
  to_submit: 'bg-[#8D7CA71F] text-[#8E7CA7]',
  submitted: 'bg-[#FFE9242E] text-[#BDAA00]',
  accepted: 'bg-[#24FFB226] text-[#00BD7B]',
  rejected: 'bg-[#FF245014] text-[#FF2450]',
  removed: 'bg-[#A059FF14] text-[#A059FF]',
  disappeared: 'bg-[#55719114] text-[#557191]',
}

interface ComplaintStatusBadgeProps {
  status: TComplaintStatus
}

export const ComplaintStatusBadge = ({ status }: ComplaintStatusBadgeProps) => {
  const { t } = useTranslation()

  return (
    <Tooltip
      title={
        status === 'disappeared' &&
        t('pages.trademarkInfringements.rejectionReasons.ad_not_found.tooltip')
      }
    >
      <div className={clsx('flex w-fit rounded-[4px] px-[6px] py-[4px]', statusClass[status])}>
        <span className={'text-[10px] font-semibold uppercase leading-[12px]'}>
          {t(`pages.trademarkInfringements.latestComplaintStatus.${status}`)}
        </span>
      </div>
    </Tooltip>
  )
}
